<template>
    <div
        class="header-separator"
        :class="{
            'header-separator--line': line
        }"
    ></div>
</template>

<script>
export default {
    name: 'HeaderSeparator',

    props: {
        line: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped>
.header-separator {
    position: relative;
    display: inline-flex;
    width: 12px;
    height: 12px;
    flex-shrink: 0;

    &--line::before {
        content: '';
        width: 1px;
        height: 12px;
        background: #999;
        margin-left: 6px;
    }
}
</style>
